import { ReviewPlain } from './review_plain.js';
import { ReviewsBaseMixin } from './reviews_base_mixin.js';

class ReviewsPlain extends ReviewsBaseMixin(Object) {
  static Review = ReviewPlain;
}

export { ReviewsPlain };
